<template>
  <div>
    <div class="sayfahead">
      <h1>{{ Sayfa.Adi }}</h1>
      <el-button-group v-if="tableDisplay" class="float-right RaporlamaIcButon">
        <el-button type="success" size="small" class="YeniBtn" @click="Excel"
                   icon="el-icon-download">Excel İndir
        </el-button>
        <a @click="Yazdir" class="el-button YeniBtn el-button--primary el-button--small"
        ><i class="el-icon-printer"></i> Yazdır
        </a>
      </el-button-group>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo" text="Lütfen Bekleyiniz."></Yukleniyor>
      <div class="raporbloksabitle">
        <el-row :gutter="24">
          <el-form :model="Form"
                   @submit.prevent.native="Getir"
                   ref="RaporForm">

            <el-col :span="3">
              <el-form-item label="Durumu" prop="Durum">
                <el-select v-model="Form.Durum" filterable>
                  <el-option
                    key="1"
                    label="Aktif"
                    value="1">
                  </el-option>
                  <el-option
                    key="0"
                    label="Pasif"
                    value="0">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>


            <el-col :span="4">
              <el-form-item label="Kullanıcı" prop="Sorumlu">
                <el-select v-model="Form.Sorumlu" filterable clearable>
                  <el-option
                    v-for="item in Kullanicilar"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="Bölge" prop="Bolge">
                <el-select v-model="Form.Bolge" filterable clearable>
                  <el-option
                    v-for="item in Bolgeler"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="3" :offset="10">
              <el-button type="primary" class="btn-block mt-3" size="medium" @click="Getir()"
                         icon="el-icon-check">Rapor Oluştur
              </el-button>
            </el-col>
          </el-form>
        </el-row>
      </div>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-alert
            v-if="!tableDisplay"
            title="Filtreleme Yapınız"
            type="info"
            :closable="false"
            description="Verilere erişebilemek için lütfen filtreleme yapınız"
          >
          </el-alert>
          <div class="yazdirtable">
            <h1>{{ Sayfa.Adi }}</h1>
            <table class="table table-bordered">
              <thead>
              <tr>
                <th>Bina Adı</th>
                <th>Adres</th>
                <th>Açıklama</th>
                <th>İletişim</th>
                <th>Bölge</th>
                <th>Sorumlu</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="t in tableData">
                <td>{{ t.Adi }}</td>
                <td>{{ t.Adres }}</td>
                <td>{{ t.Aciklama }}</td>
                <td>{{ t.Iletisim }}</td>
                <td>{{ t.oBolge }}</td>
                <td>{{ t.Sorumlu }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <el-table
            v-if="tableDisplay"
            class="table-xs yazdirma"
            :data="tableData"
            style="width: 100%"
            width="100%"
            :height="Height">
            <el-table-column
              label="Bina Adı"
              prop="Adi"
              width="250">
            </el-table-column>
            <el-table-column
              label="Adres"
              prop="Adres"
              width="300">
            </el-table-column>
            <el-table-column
              label="Açıklama"
              prop="Aciklama">
            </el-table-column>
            <el-table-column
              label="İletişim"
              prop="Iletisim"
              width="100">
            </el-table-column>
            <el-table-column
              label="Bölge"
              prop="oBolge"
              width="100">
            </el-table-column>
            <el-table-column
              label="Sorumlu"
              prop="Sorumlu"
              width="100">
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import Yukleniyor from "../../components/Doc/Yukleniyor";

const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x, i) => ({
  name: XLSX.utils.encode_col(i),
  key: i
}));


export default {
  components: {Yukleniyor},
  data() {
    return {
      Height: 0,
      lo: false,
      tableDisplay: false,
      Yetki: false,
      Kaydet: false,
      Sayfa: {
        Adi: 'Bina Raporu',
        ButtonAdi: 'Uygula',
        FiltreAdi: 'Filtreleme',
      },
      Form: {
        Durum: '1',
        Sorumlu: null,
        Bolge: null,

      },
      Kullanicilar: [
        'İbrahim',
        'Erhan',
        'Ali',
        'Alper',
        'Joker',
      ],
      Bolgeler: [
        'Talas',
        'Mimsin',
        'İldem',
        'Belsin',
        'Esentepe',
        'Erkilet',
        'Mithatpaşa',
        'Altınoluk',
        'Esenyurt',
        'Hurriyet',
        'Köşk',
        'Konaklar',
        'Zümrüt',
        'Uğurevler',
        'Yıldırım Beyazıt',
        'Sümer',
        'Merkez',
        'İlçeler',
        'Nevşehir',
        'Niğde',
        'Yozgat',
        'Kırşehir'
      ],

      tableData: [],
      ExcelData: [],


    }
  },
  methods: {

    Excel(evt) {

      const ws = XLSX.utils.json_to_sheet(this.ExcelData);
      const wb = XLSX.utils.book_new();
      ws['!cols'] = [
        {wch: 40},
        {wch: 81},
        {wch: 35},
        {wch: 12},
        {wch: 15},
        {wch: 15}
      ];

      XLSX.utils.cell_set_number_format(ws['F2'], '0.00');

      wb.Props = {
        Title: this.Sayfa.Adi + " (" + this.SecilenKasa + ")",
        Author: "Aidatim APP",
        Manager: "Aidatim APP",
        Company: "Aidatim",
        Category: "Finans",
        Keywords: "Aidatim",
        Comments: this.Sayfa.Adi + " (" + this.SecilenKasa + ")",
      };
      XLSX.utils.book_append_sheet(wb, ws, this.SecilenKasa);
      XLSX.writeFile(wb, this.Sayfa.Adi + ".xlsx");
    },

    Yazdir() {
      setTimeout(() => {
        window.print();
      }, 100);
    },

    Getir() {
      this.$refs['RaporForm'].validate((valid) => {
        if (valid) {
          this.lo = true;
          this.$store.dispatch("Post", {...this.Form, path: '_enerji/rapor/bina'})
            .then(response => {
              this.lo = false;
              if (response.Durum == "OK") {
                this.tableData = response.tableData;
                this.ExcelData = response.ExcelData;
                if (this.tableData) this.tableDisplay = true;
                this.Height = '80vh';
              } else {
                this.$message.error(response.Mesaj);
                this.hata = response.Hata;
              }
            })
        }
      })

    },

  },
  created() {
  },

}
</script>



// WEBPACK FOOTER //
// src/pages/Raporlama/Bina.vue